import { clsx } from 'clsx'
import { forwardRef } from 'react'

import type { ButtonHTMLAttributes, ReactNode } from 'react'

interface BrandLinkProperties extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
}

export const BrandLink = forwardRef<HTMLButtonElement, BrandLinkProperties>(
  ({ children, className, type = 'button', ...properties }, reference) => {
    /* --- Section 6: Render --- */
    return (
      <button {...properties} className={clsx('ui-brand-link', className)} ref={reference} type={type}>
        {children}
      </button>
    )
  }
)

BrandLink.displayName = 'BrandLink'
